import { render, staticRenderFns } from "./DetailMergeJournal.vue?vue&type=template&id=727e3102"
import script from "./DetailMergeJournal.vue?vue&type=script&lang=js"
export * from "./DetailMergeJournal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports